import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { ReferencePointTransformTool } from '../../../../../viewer/tools/reference-point-transform-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { useDesignTool } from '../hooks/use-design-tool';
import { ToolIcon } from '../tool-icon';

const ScaleToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);
  const { isEnabled } = useDesignTool();

  const onClick = () => {
    InputHandler.instance.setTool('reference-point-transform');
  };

  return (
    <>
      <ToolIcon
        active={activeTool instanceof ReferencePointTransformTool}
        callback={onClick}
        disabled={!isEnabled}
        icon={['fal', 'arrows-maximize']}
        tooltip={{
          title: t('scale.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('scale.tooltip.text', { ns: 'skyviewToolbar' }),
        }}
      />
    </>
  );
};

export { ScaleToolIcon };
